var map = {
	"./Favorites": 1134,
	"./Favorites.tsx": 1134,
	"./FavoritesDeferred": 364,
	"./FavoritesDeferred.tsx": 364,
	"./FavoritesPage": 363,
	"./FavoritesPage.dictionary": 337,
	"./FavoritesPage.dictionary.json": 337,
	"./FavoritesPage.explanation": 1135,
	"./FavoritesPage.explanation.ts": 1135,
	"./FavoritesPage.tsx": 363,
	"./actions": 99,
	"./actions/": 99,
	"./actions/index": 99,
	"./actions/index.ts": 99,
	"./components/Loader": 1022,
	"./components/Loader/": 1022,
	"./components/Loader/Loader": 972,
	"./components/Loader/Loader.dictionary": 927,
	"./components/Loader/Loader.dictionary.json": 927,
	"./components/Loader/Loader.explanation": 1136,
	"./components/Loader/Loader.explanation.ts": 1136,
	"./components/Loader/Loader.module.scss": 1035,
	"./components/Loader/Loader.tsx": 972,
	"./components/Loader/index": 1022,
	"./components/Loader/index.ts": 1022,
	"./components/NoData": 1023,
	"./components/NoData/": 1023,
	"./components/NoData/NoData": 973,
	"./components/NoData/NoData.dictionary": 930,
	"./components/NoData/NoData.dictionary.json": 930,
	"./components/NoData/NoData.explanation": 1137,
	"./components/NoData/NoData.explanation.ts": 1137,
	"./components/NoData/NoData.module.scss": 1036,
	"./components/NoData/NoData.tsx": 973,
	"./components/NoData/index": 1023,
	"./components/NoData/index.ts": 1023,
	"./components/NoDataSkeleton": 895,
	"./components/NoDataSkeleton/": 895,
	"./components/NoDataSkeleton/NoDataSkeleton": 876,
	"./components/NoDataSkeleton/NoDataSkeleton.module.scss": 928,
	"./components/NoDataSkeleton/NoDataSkeleton.tsx": 876,
	"./components/NoDataSkeleton/constants": 896,
	"./components/NoDataSkeleton/constants.ts": 896,
	"./components/NoDataSkeleton/index": 895,
	"./components/NoDataSkeleton/index.ts": 895,
	"./components/PopularMatches": 897,
	"./components/PopularMatches/": 897,
	"./components/PopularMatches/PopularMatches": 877,
	"./components/PopularMatches/PopularMatches.dictionary": 879,
	"./components/PopularMatches/PopularMatches.dictionary.json": 879,
	"./components/PopularMatches/PopularMatches.explanation": 1138,
	"./components/PopularMatches/PopularMatches.explanation.ts": 1138,
	"./components/PopularMatches/PopularMatches.module.scss": 929,
	"./components/PopularMatches/PopularMatches.tsx": 877,
	"./components/PopularMatches/index": 897,
	"./components/PopularMatches/index.ts": 897,
	"./components/SportGrid": 863,
	"./components/SportGrid/": 863,
	"./components/SportGrid/SportGrid": 846,
	"./components/SportGrid/SportGrid.module.scss": 878,
	"./components/SportGrid/SportGrid.tsx": 846,
	"./components/SportGrid/index": 863,
	"./components/SportGrid/index.ts": 863,
	"./components/TournamentTable": 847,
	"./components/TournamentTable/": 847,
	"./components/TournamentTable/TournamentTable": 839,
	"./components/TournamentTable/TournamentTable.ts": 839,
	"./components/TournamentTable/index": 847,
	"./components/TournamentTable/index.ts": 847,
	"./reducer": 294,
	"./reducer/": 294,
	"./reducer/entities": 349,
	"./reducer/entities.ts": 349,
	"./reducer/index": 294,
	"./reducer/index.js": 294,
	"./reducer/presentation": 350,
	"./reducer/presentation.ts": 350,
	"./selectors/gridEntities": 128,
	"./selectors/gridEntities.ts": 128,
	"./selectors/gridPresentation": 1083,
	"./selectors/gridPresentation.ts": 1083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1262;
module.exports = webpackContext;